/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { H1, FlexContainer, Image } from "@carrotfertility/carotene"
import { ResponsiveDrawer } from "./sidebar/ResponsiveDrawer"
import { Benefit } from "../types/Benefit"
import { FormattedMessage, useIntl } from "react-intl"

export const Heading = ({ benefit }: { benefit: Benefit }): JSX.Element => {
  const intl = useIntl()

  return (
    <FlexContainer width="100%" justifyContent="space-between" direction="column" gap="small">
      <FlexContainer direction="row" gap="small" sx={{ borderBottom: "1px solid #d9d9d9" }}>
        <Image
          src={require(`../resources/images/icn-providers.png`)}
          srcSet={require(`../resources/images/icn-providers-2x.png`)}
          altText={intl.formatMessage({ defaultMessage: "The icon for provider finder" })}
          height={36}
          width={36}
        />
        <H1>
          <FormattedMessage defaultMessage="Provider finder" />
        </H1>
      </FlexContainer>
      <ResponsiveDrawer benefit={benefit} />
    </FlexContainer>
  )
}
